import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUnreadPollCount } from '../../../polls/functions';
import { getUnreadCount } from '../../functions';
import styled, { keyframes } from 'styled-components';
const pulseAnimation = keyframes `
  0% {
    transform: scale(1);
    opacity: 1;
  }
  60% {
    transform: scale(1.3);
    opacity: 0.4;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
`;
const vibrateAnimation = keyframes `
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-2px);
  }
  50% {
    transform: translateX(2px);
  }
  75% {
    transform: translateX(-2px);
  }
  100% {
    transform: translateX(2px);
  }
`;
const Pulsate = styled.div `
  &::before {
    content: '';
    display: block;
    position: absolute;
    right: -7px;
    bottom: -7px;
    height: 50%;
    width: 50%;
    border-radius: 50%;
    background: #2AC324;
    border: 4px double lighten(red, 20%);
    animation: ${pulseAnimation} 1s ease infinite,  ${vibrateAnimation} -1.9s linear infinite;
  }
`;
/**
 * Implements a React {@link Component} which displays a count of the number of
 * unread chat messages.
 *
 * @augments Component
 */
class ChatCounter extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement(React.Fragment, null, !this.props._isOpen && this.props._count > 0 ? React.createElement(Pulsate, null,
            React.createElement("span", { style: {
                    backgroundColor: "#1ec26a",
                    borderRadius: "50%",
                    boxSizing: "border-box",
                    color: "#ffffff",
                    fontWeight: 700,
                    overflow: "hidden",
                    textAlign: "center",
                    textOverflow: "ellipsis",
                    verticalAlign: "middle",
                    bottom: "-5px",
                    fontSize: "12px",
                    lineHeight: "20px",
                    minWidth: "20px",
                    pointerEvents: "none",
                    position: "absolute",
                    right: "-5px",
                } },
                React.createElement("span", null, !this.props._isOpen
                    && (this.props._count || null))))
            :
                React.createElement(React.Fragment, null)));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code ChatCounter}'s
 * props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _count: number
 * }}
 */
function _mapStateToProps(state) {
    const { isOpen } = state['features/chat'];
    return {
        _count: getUnreadCount(state) + getUnreadPollCount(state),
        _isOpen: isOpen
    };
}
export default connect(_mapStateToProps)(ChatCounter);
